import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

/**
 * Hook to create a guided tour for the Facilities page
 * Uses Driver.js to highlight elements and show explanations
 */
export function useFacilitiesTour() {
    const { t } = useTranslation();

    const startTour = useCallback(() => {
        const driverObj = driver({
            showProgress: true,
            animate: true,
            allowClose: true,
            stagePadding: 4,
            nextBtnText: t('tour.next'),
            prevBtnText: t('tour.back'),
            doneBtnText: t('tour.last'),
            progressText: '{{current}} / {{total}}',
            steps: [
                {
                    popover: {
                        title: t('tour.facilities.intro.title'),
                        description: t('tour.facilities.intro.description'),
                    },
                },
                {
                    element: '#fab-add-button',
                    popover: {
                        title: t('tour.facilities.addButton.title'),
                        description: t('tour.facilities.addButton.description'),
                        side: 'top',
                        align: 'end',
                    },
                },
                {
                    element: 'table tbody tr td:nth-child(2) button',
                    popover: {
                        title: t('tour.facilities.facilityName.title'),
                        description: t(
                            'tour.facilities.facilityName.description',
                        ),
                        side: 'bottom',
                        align: 'start',
                    },
                },
                {
                    element: '#icon-button-0',
                    popover: {
                        title: t('tour.facilities.groupsButton.title'),
                        description: t(
                            'tour.facilities.groupsButton.description',
                        ),
                        side: 'bottom',
                        align: 'end',
                    },
                },
                {
                    element: 'input[type="text"]',
                    popover: {
                        title: t('tour.facilities.nameFilter.title'),
                        description: t(
                            'tour.facilities.nameFilter.description',
                        ),
                        side: 'bottom',
                        align: 'start',
                    },
                },
                {
                    element: '#filter-button',
                    popover: {
                        title: t('tour.facilities.filterButton.title'),
                        description: t(
                            'tour.facilities.filterButton.description',
                        ),
                        side: 'bottom',
                        align: 'end',
                    },
                },
            ],
        });

        driverObj.drive();
    }, [t]);

    return { startTour };
}
